import { render, staticRenderFns } from "./ShiftItemSplitButton.vue?vue&type=template&id=8575e87c&"
import script from "./ShiftItemSplitButton.vue?vue&type=script&lang=js&"
export * from "./ShiftItemSplitButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports